import { GroupChannelListOrder } from '@sendbird/chat/groupChannel';
export const sbuConstants = {
    collection: {
        groupChannel: {
            defaultLimit: 20,
            defaultOrder: GroupChannelListOrder.LATEST_LAST_MESSAGE,
            defaultIncludeEmpty: false,
        },
        message: {
            defaultLimit: { next: 25, prev: 25 },
            searchLimit: { next: 10, prev: 10 },
        },
    },
};
